import BaseComponent from "../../../../baseComponent.js";

export default class ColorOptions extends BaseComponent {
  constructor(props) {
    super(props);
    this.fontColors = [
      '#000000', '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b',
      '#e377c2', '#7f7f7f', '#bcbd22', '#17becf', '#001f3f', '#FFDC00'];
  }

  onOptionValueClick(e) {
    let color = $(e.target).attr("data-color");
    this.props.onOptionValueClick("color", color);
  }

  render() {
    let options = [];
    for (let i = 0; i < this.fontColors.length; i++) {
      options.push(<div className='select-option' key={"color-option-" + i} data-color={this.fontColors[i]}
                        style={{backgroundColor: this.fontColors[i]}} onClick={e => this.onOptionValueClick(e)}></div>);
    }
    return (
      <div className='tw-color-selection'>
        { options }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/textual/style/colorOptions.jsx